(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-product-gallery-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const customProductGalleryModal = document.getElementById('customProductGalleryModal');
    if (!customProductGalleryModal) return;

    const customProductGallerySwiper = new Swiper('#customProductGallerySwiper', {
      loop: true,
      zoom: {
        maxRatio: 3,
        minRatio: 1,
      },

      pagination: {
        el: '.swiper-pagination',
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });

    const customProductGalleryModalClose = customProductGalleryModal.querySelector(
      '.custom_product_gallery_modal_close'
    );
    const customProductGalleryModalBackdrop = customProductGalleryModal.querySelector(
      '.custom_product_gallery_modal_backdrop'
    );
    const zoomInBtn = customProductGalleryModal.querySelector('.custom_product_gallery_zoom_in');
    const zoomOutBtn = customProductGalleryModal.querySelector('.custom_product_gallery_zoom_out');

    // --- Read current images directly from the grid (source of truth) ---
    function getGridMedia() {
      const imgs = document.querySelectorAll('.custom_product_gallery_grid_item img');
      return Array.from(imgs).map(function (img) {
        const src = img.currentSrc || img.src;
        const fullSrc = src.replace(/width=\d+/, 'width=1600');
        return { full: fullSrc, alt: img.alt || '' };
      });
    }

    // --- Rebuild modal Swiper slides to match the grid's current images ---
    function rebuildModalSlides() {
      const media = getGridMedia();
      if (!media.length) return;

      const slidesHTML = media.map(function (m) {
        return (
          '<div class="swiper-slide">' +
            '<div class="swiper-zoom-container">' +
              '<img src="' + m.full + '" alt="' + m.alt + '">' +
            '</div>' +
          '</div>'
        );
      });

      customProductGallerySwiper.removeAllSlides();
      customProductGallerySwiper.appendSlide(slidesHTML);
      customProductGallerySwiper.update();
      if (typeof customProductGallerySwiper.loopFix === 'function') {
        customProductGallerySwiper.loopFix();
      }
    }

    function openCustomProductGalleryModal(index) {
      customProductGalleryModal.classList.add('active');
      customProductGallerySwiper.slideToLoop(index, 0);
      document.body.style.overflow = 'hidden';
    }

    function closeCustomProductGalleryModal() {
      customProductGalleryModal.classList.remove('active');
      customProductGallerySwiper.zoom.out();
      document.body.style.overflow = '';
    }

    // --- Click on grid item: rebuild fresh, then open at correct position ---
    // Uses event delegation + live DOM position (not a stored index),
    // so it keeps working even if the theme replaces grid items on variant change.
    document.addEventListener('click', function (event) {
      const item = event.target.closest('.custom_product_gallery_grid_item');
      if (!item) return;

      const allItems = Array.from(document.querySelectorAll('.custom_product_gallery_grid_item'));
      const index = allItems.indexOf(item);
      if (index === -1) return;

      rebuildModalSlides();
      openCustomProductGalleryModal(index);
    });

    if (customProductGalleryModalClose) {
      customProductGalleryModalClose.addEventListener('click', closeCustomProductGalleryModal);
    }
    if (customProductGalleryModalBackdrop) {
      customProductGalleryModalBackdrop.addEventListener('click', closeCustomProductGalleryModal);
    }

    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        customProductGallerySwiper.zoom.in();
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        customProductGallerySwiper.zoom.out();
      });
    }

    // --- Watch the grid for ANY change (variant switch, image swap, re-render) ---
    // and keep the modal's slides in sync automatically, even while modal is closed.
    const galleryContainer = document.querySelector('.custom_product_gallery');
    if (galleryContainer) {
      let debounceTimer;
      const observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(rebuildModalSlides, 100);
      });
      observer.observe(galleryContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src'],
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-details-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.main_product_similar_products');
    if (!wrapper) return;

    const tabItems = wrapper.querySelectorAll('.tabs_indicator_item');

    function activateTab(targetId) {
      // targetId is expected WITHOUT the leading #
      wrapper.querySelectorAll('.tabs_indicator_item.active').forEach(function (item) {
        item.classList.remove('active');
      });
      wrapper.querySelectorAll('.tabs_panel.active').forEach(function (panel) {
        panel.classList.remove('active');
      });

      const link = wrapper.querySelector('.tabs_indicator_item a[href="#' + targetId + '"]');
      const panel = document.getElementById(targetId);

      if (link) link.closest('.tabs_indicator_item').classList.add('active');
      if (panel) panel.classList.add('active');
    }

    tabItems.forEach(function (item) {
      const link = item.querySelector('a');
      if (!link) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = link.getAttribute('href').replace(/^#/, '');
        activateTab(targetId);
      });
    });

    // Activate the first tab whose panel actually exists
    for (let i = 0; i < tabItems.length; i++) {
      const link = tabItems[i].querySelector('a');
      if (!link) continue;
      const targetId = link.getAttribute('href').replace(/^#/, '');
      if (document.getElementById(targetId)) {
        activateTab(targetId);
        break;
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const modal = document.getElementById('quick-view-modal');
    if (!modal) return;

    const body = modal.querySelector('.quick-view-body');
    const overlay = modal.querySelector('.quick-view-overlay');
    const closeBtn = modal.querySelector('.quick-view-close');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      body.innerHTML = '';
    }

    async function loadProduct(productUrl) {
      body.innerHTML = '<div class="quick-view-loading">Loading...</div>';
      openModal();

      try {
        const response = await fetch(productUrl);
        if (!response.ok) throw new Error('Network error: ' + response.status);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const source = doc.querySelector('.product-page');

        if (source) {
          const clone = source.cloneNode(true);

          Array.from(clone.children).forEach(function (child) {
            const hasEssentialContent = child.querySelector('#product-page');
            if (!hasEssentialContent) {
              child.remove();
            }
          });

          body.innerHTML = clone.outerHTML;

          // "Pair it With / Similar Products" mini section hata do
          const similarProductsSection = body.querySelector('.main_product_similar_products');
          if (similarProductsSection) {
            similarProductsSection.remove();
          }

          if (window.Alpine && typeof window.Alpine.initTree === 'function') {
            window.Alpine.initTree(body);
          }
        } else {
          body.innerHTML = '<p>404 Error</p>';
        }
      } catch (err) {
        body.innerHTML = '<p>Please Try Again...</p>';
        console.error('Quick view fetch error:', err);
      }
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.quick-view-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const productUrl = btn.dataset.productUrl;
      if (!productUrl) return;

      loadProduct(productUrl);
    });

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
